export const dialogModule = {
  namespaced: true,
  state: {
    loadingDialog: { text: '', value: false },
  },
  mutations: {
    // Sem payload = fechar. Era um toggle, mas o ramo nunca teve efeito:
    // a atribuição seguinte o sobrescrevia com { ...undefined }.
    SET_LOADING_DIALOG(state, payload) {
      if (!payload) {
        state.loadingDialog = { text: '', value: false }
        return
      }
      state.loadingDialog = { ...payload }
    },
  },
  actions: {
    setLoadingDialog({ commit }, payload) {
      commit('SET_LOADING_DIALOG', payload)
    },
  },
  getters: {
    loadingDialog: (state) => state.loadingDialog,
  },
}
